import { makeStyles, tokens } from '@fluentui/react-components';

export const trendSubclasses = {
    positive: 'positive',
    negative: 'negative',
} as const;

export const useMetricsValueTileStyles = makeStyles({
    value: {
        display: 'flex',
        flexDirection: 'column',
    },
    labelWithTooltip: {
        textDecoration: 'underline dotted',
    },
    number: {
        display: 'flex',
        gap: '12px',
        alignItems: 'center',
    },
    trend: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: '4px',
        color: tokens.colorBrandBackgroundInverted,
        gap: '4px',
        padding: '4px',
        backgroundColor: tokens.colorNeutralForeground2,

        '&.positive': {
            backgroundColor: tokens.colorStatusSuccessBackground3,
        },

        '&.negative': {
            backgroundColor: tokens.colorStatusDangerBackground3,
        },

        '& svg': {
            fontSize: '1.125rem',
        },
    },
});
